<div class="navigation">
	<ng-content select="[navigation]"></ng-content>
</div>
<div class="scroll-container">
	<div class="content-container">
		<ng-content></ng-content>
	</div>
</div>
